import { render, staticRenderFns } from "./LogoutSideNavEntry.vue?vue&type=template&id=b9946bb2&"
import script from "./LogoutSideNavEntry.vue?vue&type=script&lang=js&"
export * from "./LogoutSideNavEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LogoutSideNavEntry.vue"
export default component.exports